<template>
  <div class="landing-wrapper">
    <div class="row landing-header">
      <div class="col-sm-6 col-md-5 col-lg-5">
        <img src="static/assets/img/robot-noproduct.png">
      </div>
      <div class="col-sm-6 col-md-7 col-lg-7">
        <img src="static/assets/img/header-pandoprofile.png">
      </div>
    </div>
    <div class="row landing-description">
      <img src="static/assets/img/pandoprofile.png">
      <p>Bringing CRM intelligence to a whole new level. Connect AutoAlert to your CRM and identify those who are in market,
        engaged and ready to buy.</p>
      <p>Get
        <span style="text-transform: uppercase; color: #172751">Pando</span>
        <span style="text-transform: uppercase;">Profile.</span>
      </p>
      <p>Call:
        <a href="tel:9333019536">933.301.9536</a>
        <span style="padding: 0 20px;">|</span>Email:
        <a href="mailto:clientcare@autoalert.com">ClientCare@AutoAlert.com</a>
      </p>
    </div>
  </div>
</template>

<script>
  export default {

  }

</script>

<style scoped>
  .landing-wrapper {
    text-align: center;
  }

  .landing-header {
    border-bottom: 1px solid #e7e7e7;
  }

  .landing-description {
    padding-top: 50px;
    max-width: 800px;
    margin: 0 auto;
  }

  .landing-description p:nth-of-type(1) {
    max-width: 550px;
    margin: 0 auto;
    color: #444b4f;
    font-size: 20px;
    font-weight: 300;
    padding: 35px 0;
  }

  .landing-description p:nth-of-type(2) {
    color: #1f8bd5;
    font-size: 20px;
    font-weight: 400;
  }

  .landing-description p:nth-of-type(3) {
    color: #1f8bd5;
    font-size: 16px;
    padding: 30px 0;
    font-weight: 400;
  }

  .landing-description p:nth-of-type(3)>a,
  .landing-description p:nth-of-type(3)>a:hover,
  .landing-description p:nth-of-type(3)>a.focus,
  .landing-description p:nth-of-type(3)>a.visited {
    color: #1f8bd5;
    text-decoration: none;
  }

</style>



// WEBPACK FOOTER //
// src/components/Splash/Splash.vue